"use client"

import { Alert } from "@chakra-ui/react/alert"
import { Box, BoxProps } from "@chakra-ui/react/box"
import React from "react"

interface IErrorMessage extends BoxProps {
  status?: "error" | "warning" | "info" | "success"
  title?: string
  message?: string
}

const ErrorMessage: React.FC<IErrorMessage> = ({
  message = "Please try again.",
  status = "error",
  title = "There was error!",
  ...props
}) => {
  return (
    <Box my={4} {...props}>
      <Alert.Root status={status}>
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Title>{title}</Alert.Title>
          <Alert.Description>{message}</Alert.Description>
        </Alert.Content>
      </Alert.Root>
    </Box>
  )
}

export default ErrorMessage
